import type { UpdateReportConfigurationRequestType } from 'src/api/generated/touring/types';
import type { EditReportMailingFormValuesType } from '../../types';

export const mapVenueFormValuesToUpdateRequest = (
  values: EditReportMailingFormValuesType
): UpdateReportConfigurationRequestType => ({
  label: values.label.trim(),
  isEnabled: values.isEnabled,
  sendWeekday: values.sendWeekday,
  sendTime: `${values.sendHour}:${values.sendMinute}`,
  locale: values.locale,
  configurationOptions: {
    kind: 'VENUE',
    recipientGroupId: values.recipientGroupId,
  },
  profileNote: values.profileNote.trim() || null,
  internalNote: values.internalNote.trim() || null,
});
